import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy singular URL → plural. */
export const Route = createFileRoute('/category/$id')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/categories/$categoryId',
      params: { categoryId: params.id },
      search,
      replace: true,
    });
  },
});
